var timings = {
  /**
   * `slowest` timing: 300ms
   */
  slowest: 300,
  /**
   * `slower` timing: 250ms
   */
  slower: 250,
  /**
   * `base` timing: 200ms
   */
  base: 200,
  /**
   * `faster` timing: 150ms
   */
  faster: 150,
  /**
   * `fastest` timing: 100ms
   */
  fastest: 100,
  /**
   * `extraFast` timing: 50ms
   */
  extraFast: 50
};

export { timings };
